import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useLogin } from "../../hooks/useLogin";
import { GoabAppHeaderMenu, GoabModal, GoabButtonGroup, GoabButton } from "@abgov/react-components";
import { getLoggedOutEndpoint } from "../../../ServiceUtils/auth";
import { selectCurrentUser } from '../../../Store/api/auth/authSelectors';
import { useGetApplicationListQuery } from "../../../Store/api/application/applicationApi";
import { useAnalyticsStep } from '../../../MPP-Common-SPA/utils/useAnalyticsStep';
import { trackEvent } from '../../../MPP-Common-SPA/utils/analytics';
import { SIGN_IN_BUTTON_EVENT, SIGN_IN_BUTTON_PARAM_KEY } from '../../../MPP-Common-SPA/utils/analytics-constants';
import { useUnsavedChanges } from '../../../MPP-Common-SPA/common/unsavedChangesContext';

const HeaderComponent = () => {
  const { isLoggedIn, givenName, middleName, surname, isProxyUser } = useSelector(selectCurrentUser);
  const fullName = `${givenName} ${middleName} ${surname}`

  const { data: applicationList, isLoading: isApplicationsLoading } = useGetApplicationListQuery(undefined, {
    skip: !isLoggedIn,
  });

  const currentStep = useAnalyticsStep();

  const { handleLogout, handleLogin } = useLogin();
  const { hasUnsavedChanges, clearDirty } = useUnsavedChanges();
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);

  const shouldShowApplicationsTab = !isProxyUser && applicationList?.length > 0;

  const handleLoginWithAnalytics = () => {
    trackEvent(
          SIGN_IN_BUTTON_EVENT, 
          { [SIGN_IN_BUTTON_PARAM_KEY]: currentStep }
      );
    handleLogin();
  };

  const handleGoToWorkspace = (e) => {
    e.preventDefault();
    if (hasUnsavedChanges) {
      setShowUnsavedModal(true);
    } else {
      handleConfirmSignOut();
    }
  };

  const handleConfirmSignOut = () => {
    setShowUnsavedModal(false);
    clearDirty();
    if (isProxyUser) {
      handleLogout();
    } else {
      handleLogout(getLoggedOutEndpoint());
    }
  };

  return (
    <>
      {isLoggedIn ? (
        <>
          {!isApplicationsLoading && shouldShowApplicationsTab && <Link to="/applications">My applications</Link>}
          <GoabAppHeaderMenu heading={fullName} leadingIcon="person-circle">
            <a
              href="#"
              className="interactive"
              onClick={handleGoToWorkspace}
            >
              {!isProxyUser ? 'Sign out' : 'Go to workspace'}
            </a>
          </GoabAppHeaderMenu>
        </>
      ) : (             
        <Link to=""
          className="interactive"
          onClick={() => handleLoginWithAnalytics()}
          style={{ height: "100%" }}
        >
          Sign in
        </Link>
      )}

      <GoabModal
        heading="Unsaved changes"
        open={showUnsavedModal}
        maxWidth="480px"
        actions={
          <GoabButtonGroup alignment="end">
            <GoabButton type="secondary" onClick={() => setShowUnsavedModal(false)}>
              Cancel
            </GoabButton>
            <GoabButton type="primary" variant="destructive" onClick={handleConfirmSignOut}>
              {!isProxyUser ? 'Sign out' : 'Leave page'}
            </GoabButton>
          </GoabButtonGroup>
        }
      >
        <p>You have unsaved changes. If you {!isProxyUser ? 'sign out,' : 'leave this page, you will return to your workspace and'} your progress will be lost.</p>
        <br/>
        <p>To continue your application at another time, click "Finish later" located at the bottom of your application.</p>
      </GoabModal>
    </>
  );
};

export default HeaderComponent;
